import React from "react";

export interface IconButtonProps {
  onClick?: () => void;
  children: React.ReactNode;
  className?: string;
  type?: "button" | "submit" | "reset";
}

export const IconButton = ({ onClick, className, children, type = "button" }: IconButtonProps): JSX.Element => {
  return (
    <button
      type={type}
      className={`px-2 py-2 btn dark:bg-slate-800 border-slate-200 dark:border-slate-700 hover:border-slate-300 dark:hover:border-slate-600 ${className}`}
      onClick={onClick}
    >
      {children}
    </button>
  );
};
